exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".trans-btn[data-v-61b5b006]{width:30px;height:30px;background:transparent;border:none;display:flex;justify-content:center;align-items:center;padding:0;cursor:pointer;border-radius:5px;transition:background-color .25s ease-in-out}.trans-icon[data-v-61b5b006]{height:auto;width:1.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-61b5b006","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GroupTranslator.vue
// module id = 970
// module chunks = 0